/**
 * This service is used to sync the funnel guard with component.
 */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * This service is used to sync the funnel guard with component.
 */
@Injectable({
    providedIn: 'root',
})
export class FunnelGuardSyncService {
    private readonly funnelGuardSync = new BehaviorSubject<any>(null);

    /**
     * This method is used to get the funnel guard sync.
     * @returns funnelGuardSync
     */
    getFunnelGuardSync() {
        return this.funnelGuardSync.asObservable();
    }

    /**
     * This method is used to set the funnel guard sync.
     * @param data - boolean
     * @returns void
     */
    setFunnelGuardSync(data: boolean) {
        this.funnelGuardSync.next(data);
    }
}
